import { render, staticRenderFns } from "./SectionCategories.vue?vue&type=template&id=58ade4a4"
import script from "./SectionCategories.vue?vue&type=script&lang=js"
export * from "./SectionCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports